// src/stores/app.js
import { defineStore } from 'pinia';

export const useAppStore = defineStore('app', {
  state: () => ({
    // UI
    sideMenuOpen: false,
    betSlipOpen: false,
    hideAccessAccount: false,

    // Betting
    currency: 'KSH',
    stake: 0,
    betslip: [], // { id, home, away, marketType, outcome, odds, extra, kickoff, status }
  }),

  getters: {
    count: (s) => s.betslip.length,
    hasBets: (s) => s.betslip.length > 0,
    totalOdds: (s) =>
      s.betslip.reduce((acc, b) => acc * (Number(b?.odds) || 1), 1),
    payout: (s) => (Number(s.stake) || 0) * (s.totalOdds || 1),
  },

  actions: {
    /* header/sidebar */
    setHideAccessAccount(v) { this.hideAccessAccount = !!v; },
    toggleSideMenu(force) {
      const next = typeof force === 'boolean' ? force : !this.sideMenuOpen;
      this.sideMenuOpen = next;
      // Sync overlay visibility (Vue handles the menu via :class binding)
      const overlay = document.getElementById('overlay');
      if (overlay) {
        const method = next ? 'add' : 'remove';
        overlay.classList[method]('show');
      }
    },
    closeSideMenu() { this.toggleSideMenu(false); },

    /* bet slip panel */
    toggleBetSlip(force) {
      this.betSlipOpen = typeof force === 'boolean' ? force : !this.betSlipOpen;
      // if you have a drawer element you want to class-toggle, do it here
      const drawer = document.getElementById('BetSlipContent');
      drawer?.classList?.[this.betSlipOpen ? 'add' : 'remove']('open');
    },
    closeBetSlip() { this.toggleBetSlip(false); },

    /* stake & bets */
    setStake(v) { this.stake = Number(v) || 0; },
    addBet(b) {
      const id = b?.id ?? crypto.randomUUID();
      this.betslip.push({ ...b, id });
    },
    removeBet(id) { this.betslip = this.betslip.filter(b => b.id !== id); },
    removeAllBets() { this.betslip = []; },
    removeExpiredBets() { this.betslip = this.betslip.filter(b => b.status !== 'expired'); },
  },
});
